module.exports = __webpack_public_path__ + "static/img/2.c7dc6c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/2.png
// module id = grYv
// module chunks = 0